import { render, staticRenderFns } from "./SkeletonText.vue?vue&type=template&id=4502f05b&scoped=true&"
var script = {}
import style0 from "./SkeletonText.vue?vue&type=style&index=0&id=4502f05b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4502f05b",
  null
  
)

export default component.exports